import { Observable, Subject } from 'rxjs';

import { SnSearchItem } from '@lib/api/entities';
import { SnSearchbarOptionConfig } from '@lib/ui/searchbar';

export interface SearchItemClickEvent {
  item: SnSearchItem;
  type: 'search' | 'address';
}

export interface MapSearchServiceInterface {
  search(value: string): Observable<SnSearchbarOptionConfig[]>;
  searchItemClick$: Observable<SearchItemClickEvent>;
}

